import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e2bebd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restart_account_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"restart_account_title\" data-v-3e2bebd8>メールをご確認ください</h1><p class=\"restart_account_description\" data-v-3e2bebd8><span class=\"restart_account_description_punctuation\" data-v-3e2bebd8>ご入力いただいたメールアドレス宛に</span><span class=\"restart_account_description_punctuation\" data-v-3e2bebd8>転職支援サービスの再開にあたり</span><span class=\"restart_account_description_punctuation\" data-v-3e2bebd8>手続のご案内をお送りいたしました</span></p>", 2)
const _hoisted_4 = { class: "restart_account_button_login" }
const _hoisted_5 = { class: "restart_account_button_top" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"restart_account_note\" data-v-3e2bebd8><p class=\"login_forget_note_text\" data-v-3e2bebd8>メールが届かない場合、入力情報に誤りがあることが考えられます。総合窓口までお問い合わせください。</p><p class=\"restart_account_mail_title\" data-v-3e2bebd8>＜総合窓口＞</p><p class=\"login_forget_mail_text\" data-v-3e2bebd8> メール <a class=\"text_link\" href=\"mailto:webmaster@massmedian.co.jp\" data-v-3e2bebd8>webmaster@massmedian.co.jp</a></p><p class=\"restart_account_mail_annotation\" data-v-3e2bebd8> 原則として営業時間の範囲内でご返答してまいります。 <br data-v-3e2bebd8> 営業時間外にいただいたお問い合わせは翌営業日より順次対応いたします。 <br data-v-3e2bebd8> 予めご了承ください。 <br data-v-3e2bebd8> 【営業時間】10:00～18:00（年末年始、土・日曜日、祝日、当社休業日を除く） </p></div>", 1)

import BaseButton from '@/components/BaseButton.vue';
import LinkToTopButton from '@/components/LinkToTopButton.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestartAccountCompleteView',
  setup(__props) {

const router = useRouter();
const transitionLoginPage = () => {
  router.push({ name: 'a10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: transitionLoginPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("ログイン")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(LinkToTopButton)
      ]),
      _hoisted_6
    ])
  ]))
}
}

})